import "./public-path.js";
import "core-js/es";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "@csstools/normalize.css";
import App from "./App";
import store from "./common/store";
import "./index.less";
import AppRoute from "./route";
import * as serviceWorker from './serviceWorker';
import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";

// define sub app render
function render(props: MFEPropsType) {
    const {container} = props;
    // this render would mount on sub app's index.html
    ReactDOM.render(<Provider store={store}>
        <AppRoute/>
    </Provider>, container ? container.querySelector('#root') : document.querySelector('#root'));
}


// if remove this code, this app would display as a blank page when it runs without master app
if (!(window as any).__POWERED_BY_QIANKUN__) {
    ReactDOM.render(
        <Provider store={store}>
            <App/>
        </Provider>,
        document.getElementById("root")
    );
}

// eslint-disable-next-line @typescript-eslint/require-await
export async function bootstrap() {
    console.log('[react16] react app bootstraped');
}

// eslint-disable-next-line @typescript-eslint/require-await
export async function mount(props: MFEPropsType) {
    console.log('[react] props from main framework', props);
    render(props);
}

// eslint-disable-next-line @typescript-eslint/require-await
export async function unmount(props: MFEPropsType) {
    const {container} = props;
    ReactDOM.unmountComponentAtNode(
        container
            ? container.querySelector('#root')
            : document.querySelector('#root')
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();